import { render, staticRenderFns } from "./EditorHintBar.vue?vue&type=template&id=382e2b30&scoped=true&"
import script from "./EditorHintBar.vue?vue&type=script&lang=js&"
export * from "./EditorHintBar.vue?vue&type=script&lang=js&"
import style0 from "./EditorHintBar.vue?vue&type=style&index=0&id=382e2b30&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e2b30",
  null
  
)

export default component.exports